import Slider from '@ant-design/react-slick';
import Link from 'next/link';

import { OFFERS } from '../../constants/routes';
import CMSCard from '../CMSCard/CMSCard';
import PageTitle from '../Page Title/PageTitle';
import Newsletter from '../Sidebar/Newsletter';
import NextArrow from '../swiper-buttons/NextArrow';
import PrevArrow from '../swiper-buttons/PrevArrow';

import styles from './LeafletLayout.module.scss';
import LeafletSlide from './LeafletSlide';

export default function LeafletLayout({ leaflet, fulladiaLinks, slug }) {
  if (!leaflet || !leaflet[0]) return null;

  const [leafletData] = leaflet;

  return (
    <section className={styles.page}>
      <PageTitle title={leafletData.title} />
      <div className={styles.leafletContainer}>
        <div className={styles.leaflet}>
          <h2 className={styles.leafletTitle}>{leafletData.title}</h2>
          {leafletData.fields.sections[0].pdf && (
            <>
              <Slider
                key={leafletData.fields.sections[0].pdf.id}
                {...{
                  infinite: true,
                  className: styles.slider,
                  nextArrow: <NextArrow leaflet />,
                  prevArrow: <PrevArrow leaflet />,
                  slidesToScroll: 1,
                  slidesToShow: 1,
                  speed: 500,
                }}
              >
                {leafletData.fields.sections[0].cover_image?.map((slide, index) => (
                  <LeafletSlide
                    key={slide.id}
                    slide={slide}
                    _index={index}
                    leafletUrl={leafletData.fields.sections[0]['leaflet-url']}
                    slug={slug}
                  />
                ))}
              </Slider>
              <div
                className={styles.textContent}
                dangerouslySetInnerHTML={{
                  __html: leafletData.fields.sections[0].content,
                }}
              />
              <div className={styles.linkButtonContainer}>
                <Link href={OFFERS}>
                  <a className={styles.offersLink}>Ξεκίνα τις αγορές σου!</a>
                </Link>
                <a
                  className={styles.pdfLink}
                  target="_blank"
                  rel="noreferrer"
                  href={leafletData.fields.sections[0].pdf.path}
                >
                  Κατέβασε το pdf!
                </a>
              </div>
            </>
          )}
          {leafletData.fields.sections[0]['leaflet-url'] &&
            !leafletData.fields.sections[0].pdf &&
            leafletData.fields.sections.map(s => (
              <div className={styles.videoContainer} key={s['leaflet-url']}>
                <div className={styles.textContent} dangerouslySetInnerHTML={{ __html: s.content }} />
                <iframe className={styles.video} title="video" src={s['leaflet-url']} />
              </div>
            ))}
          {leafletData.fields.sections[0].cover_image && !leafletData.fields.sections[0].pdf && (
            <div className={styles.imgContainer}>
              <img
                className={styles.img}
                src={leafletData.fields.sections[0].cover_image.path}
                alt="εικόνα με προσφορές"
              />
              <div
                className={styles.textContent}
                dangerouslySetInnerHTML={{
                  __html: leafletData.fields.sections[0].content,
                }}
              />
            </div>
          )}
        </div>
        <div className={styles.asideContainer}>
          <CMSCard>
            <h3 className={styles.asideTitle}>Φυλλάδια</h3>
            <ul className={styles.offersList}>
              {fulladiaLinks.data[0].fields.fulladiaLink.map(link => (
                <li className={styles.listItemBorder} key={link['fulladiaLink-url']}>
                  <Link href={link['fulladiaLink-url']}>
                    <a className={styles.links}>{`${link['fulladiaLink-title']}`}</a>
                  </Link>
                </li>
              ))}
            </ul>
          </CMSCard>
          {process.env.hasNewsletter && <Newsletter />}
        </div>
      </div>
    </section>
  );
}
